module.exports = __webpack_public_path__ + "static/img/galeria-80px.879a7503.png";